export const vFitText = {
    mounted(el) {
        const resizeText = () => {
            if (!el.offsetWidth) return; // évite les 0px

            let fontSize = 42;
            el.style.fontSize = fontSize + "px";
            el.style.whiteSpace = "nowrap";
            el.style.overflow = "hidden";

            while (el.scrollWidth > el.offsetWidth && fontSize > 10) {
                fontSize--;
                el.style.fontSize = fontSize + "px";
            }
        };

        // Observe les changements de taille du conteneur
        const observer = new ResizeObserver(resizeText);
        observer.observe(el);

        // Sauvegarde pour cleanup
        el._fitTextObserver = observer;

        // Exécute après le rendu
        requestAnimationFrame(resizeText);
    },

    updated(el) {
        // Recalcule si le texte change
        requestAnimationFrame(() => el._fitTextObserver?.callback?.());
    },

    unmounted(el) {
        el._fitTextObserver?.disconnect();
    },
};
